import * as React from 'react';

const Shimmer = () => {
    return (<div className="shimmer">

        <box className="shine"></box>

        <div>
            <lines className="shine"></lines>
            <lines className="shine"></lines>
            <lines className="shine"></lines>
        </div>

        <box className="shine"></box>

        <div>
            <lines className="shine"></lines>
            <lines className="shine"></lines>
            <lines className="shine"></lines>
        </div>


        {/* 
<photo className="shine"></photo>
<photo className="shine"></photo>

<br/>

<box className="shine"></box>

<div>
<lines className="shine"></lines>
<lines className="shine"></lines>
<lines className="shine"></lines> */}
        {/* </div> */}
    </div>
    )
}

export default Shimmer;